import React, { ErrorInfo } from 'react'
import * as Sentry from '@sentry/react'
import { SENTRYTAGS } from '../../logging'
import { WemoloTypography } from '../../components/Wemolo'
import styles from './LiveViewErrorBoundary.module.css'

export class LiveViewErrorBoundary extends React.Component<
    { children: React.ReactNode },
    { hasError: boolean; error: Error | null }
> {
    constructor(props: { children: React.ReactNode }) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error:', error)
        console.error('Error Info:', errorInfo)

        Sentry.setTag('component', SENTRYTAGS.LIVEVIEW)
        Sentry.captureException(error, {
            extra: {
                componentStack: errorInfo.componentStack
            }
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.root}>
                    <WemoloTypography variant="headline-small" tag="h3">
                        Something went wrong
                    </WemoloTypography>
                    <pre className={styles.errorMessage}>{this.state.error?.message}</pre>
                </div>
            )
        }
        return this.props.children
    }
}
